export const attributePrefix = 'attribute_';

export const priceRangeCode = 'price';

export const openState = 'open';

export const colorFilterCode = 'color';

export const minItemsForSearch = 10;
